/**
 * 课程卡片模式切换
 */
export default {
  modeNames: {
    list: 'List mode',
    card: 'Card mode',
  },
}
